module.exports = __webpack_public_path__ + "img/wf.05522b9f.svg";